/* eslint-disable @typescript-eslint/promise-function-async */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

import { AuthGuardService } from './core/guards/auth-guard.service';
import { MaintenanceComponent } from './modules/general/maintenance/maintenance.component';
import { NotFoundComponent } from './modules/general/not-found/not-found.component';
import { RouteUtils } from './shared/utils/route/route.util';

const applicationRoutes: Routes = [
	{
		path: RouteUtils.endpoints.auth.path,
		loadChildren: () =>
			import('./modules/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: '',
		canActivateChild: [AuthGuardService],
		loadChildren: () =>
			import('./sanus/sanus.module').then((m) => m.SanusModule),
	},
	{
		path: '2fa',
		loadChildren: () =>
			import('./modules/two-factor-auth/two-factor-auth.module').then(
				(m) => m.TwoFactorAuthModule,
			),
	},
	{ path: '**', component: NotFoundComponent },
];

const maintenanceRoutes: Routes = [
	{ path: '**', component: MaintenanceComponent },
];

const routes: Routes = environment.isMaintenanceMode
	? maintenanceRoutes
	: applicationRoutes;

@NgModule({
	exports: [RouterModule],
	imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
